import SDKVerification from '@/docs-partials/sdk/verification.mdx';
import * as React from 'react';
export default {
  SDKVerification,
  React
};